import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import ExternalToMapper from '@/bundles/GroupFilters/mappers/ExternalToMapper';
import { generateParams } from '@/utils/helpers';
import { IGetCitiesDto } from '@/bundles/GroupFilters/dto';

export default class ExternalService {
  private readonly transport: HttpTransport;
  private readonly errorMapper: ErrorMapper;
  private readonly cityMapper: ExternalToMapper;

  constructor ({
    transport,
    errorMapper,
    cityMapper,
  }: {
    transport: HttpTransport,
    errorMapper: ErrorMapper,
    cityMapper: ExternalToMapper,
  }) {
    this.transport = transport;
    this.errorMapper = errorMapper;
    this.cityMapper = cityMapper;
  }

  async getCities (params: IGetCitiesDto): Promise<string[]> {
    try {
      const arrayParams = Object.entries(params).map(([name, value]) => {
        return { name, value };
      });
      const paramsString = generateParams(arrayParams);

      return await this.transport.get(`/city/cities${paramsString}`);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }
}
